import { useHistory, useParams } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Cartao, Titulo, TituloAcoes, Conteudo, Rotulo, ValorDestacado, Arquivo, ArquivoIcone, ArquivoConteudo, ArquivoNome, ArquivoTamanho, ArquivoAcao, Timestamp } from "../styles";
import { IconCheckCircunferenciaConclusao, IconExternalLink, IconClock, IconDocumentUpload } from "../../../icons/IconesSistema";
import { IconUser } from "../../../icons";
import { formatFileSize } from "../../../../utility/byteSizeUtils";
import { 
  RodapeConclusao,
  RodapeContainer,
  AvatarContainer,
  InfoContainer,
  NomeContainer,
  NomeProfissional,
  CodigoProfissional
} from "./styles";
import { comum } from "../../../../styles/Themes/light";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useAuth } from "../../../../contexts/UserContext";

export default function ObservacoesConclusao({ demanda, loading = false, onNavigateToFile }: any) {
  const { user } = useAuth();
  const history = useHistory();
  const { id: idDemanda } = useParams<{ id: string }>();

  const handleArquivoClick = (arquivo: any) => {
    if (onNavigateToFile && arquivo?.id_proposta_arquivo) {
      onNavigateToFile(arquivo.id_proposta_arquivo);
    } else if (idDemanda) {
      history.push(`/demandas/${idDemanda}/anexos`);
    }
  };

  const formatarDataRelativa = (data: string | Date | null | undefined): string => {
    if (!data) return "";
    try {
      const dataFormatada = new Date(data);
      if (Number.isNaN(dataFormatada.getTime())) return "";
      return formatDistanceToNow(dataFormatada, { 
        addSuffix: true, 
        locale: ptBR 
      });
    } catch (error) {
      return "";
    }
  };

  const historicoConclusao = (demanda as any)?.historico
    ?.filter((h: any) => h.acao?.toLowerCase().includes('concluiu demanda'))
    ?.sort((a: any, b: any) => {
      const dataA = new Date(a.criado || 0).getTime();
      const dataB = new Date(b.criado || 0).getTime();
      return dataB - dataA;
    })?.[0];

  const mensagem = demanda?.info_conclusao || historicoConclusao?.justificativa || "--";
  const nomeProfissional = historicoConclusao?.nome_responsavel || demanda?.nomeProfissional || demanda?.nome_profissional || "";
  const idProfissional = historicoConclusao?.id_responsavel || demanda?.id_profissional || demanda?.id_usuario;
  const dataEnvio = historicoConclusao?.criado || demanda?.data_conclusao;
  const dataRelativa = formatarDataRelativa(dataEnvio);
  const arquivosFinais = (demanda?.arquivos || []).filter((arquivo: any) => arquivo.arquivo_final === "sim");
  
  const codigoFormatado = idProfissional ? `D${idProfissional}` : "";
  const temIdentificacao = nomeProfissional || codigoFormatado;

  const arquivosConclusao = arquivosFinais.filter((arquivo: any) => arquivo.tipo_arquivo === "arquivo_conclusao");
  const arquivosAta = arquivosFinais.filter((arquivo: any) => arquivo.tipo_arquivo === "ata_processo");

  if (loading) {
    return (
      <Cartao>
        <Titulo>
          <Skeleton circle width={18} height={18} />
          <Skeleton width={200} height={18} />
          <div style={{ marginLeft: 'auto' }}>
            <Skeleton width={200} height={14} />
          </div>
        </Titulo>
        <Conteudo>
          <Skeleton width={180} height={14} style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height={60} borderRadius={6} style={{ marginBottom: '16px' }} />
          <Skeleton width={220} height={14} style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height={48} borderRadius={8} style={{ marginBottom: '16px' }} />
          <Skeleton width={120} height={14} style={{ marginBottom: '8px' }} />
          <Skeleton width="100%" height={48} borderRadius={8} />
        </Conteudo>
      </Cartao>
    );
  }

  const podeVerConclusao = user?.profile === 'admin' || 
                           user?.profile === 'operador' || 
                           (user?.profile === 'comum' && Number(user?.id) === demanda?.id_usuario);

  if (!podeVerConclusao) {
    return null;
  }

  return (
    <Cartao>
      <Titulo>
        <IconCheckCircunferenciaConclusao size={18} color="#10b981" />
        Conclusão do profissional
        {dataRelativa && (
          <TituloAcoes>
            <Timestamp>
              <IconClock size={14} />
              {dataRelativa}
            </Timestamp>
          </TituloAcoes>
        )}
      </Titulo>
      <Conteudo>
        {temIdentificacao && (
          <RodapeConclusao>
            <RodapeContainer>
              <AvatarContainer>
                <IconUser color={comum.colors.primaryRed400} size={20} />
              </AvatarContainer>
              <InfoContainer>
                <NomeContainer>
                  {nomeProfissional ? (
                    <>
                      <NomeProfissional>{nomeProfissional}</NomeProfissional>
                      {codigoFormatado && <CodigoProfissional>{codigoFormatado}</CodigoProfissional>}
                    </>
                  ) : codigoFormatado ? (
                    <NomeProfissional>{codigoFormatado}</NomeProfissional>
                  ) : null}
                </NomeContainer>
              </InfoContainer>
            </RodapeContainer>
          </RodapeConclusao>
        )}

        <Rotulo>Mensagem da Conclusão:</Rotulo>
        <ValorDestacado>{mensagem}</ValorDestacado>

        {arquivosConclusao.length > 0 && (
          <div>
            <Rotulo>Arquivo de conclusão preenchido:</Rotulo>
            <ValorDestacado>
              {arquivosConclusao.map((arquivo: any, index: number) => (
                <Arquivo key={arquivo.id_proposta_arquivo || index} onClick={() => handleArquivoClick(arquivo)}>
                  <ArquivoIcone>
                    <IconDocumentUpload size={16} color="#64748b" />
                  </ArquivoIcone>
                  <ArquivoConteudo>
                    <ArquivoNome>{arquivo?.caminho?.split("/").pop() || "--"}</ArquivoNome>
                    {arquivo.tamanho != null && (
                      <ArquivoTamanho>{formatFileSize(arquivo.tamanho)}</ArquivoTamanho>
                    )}
                  </ArquivoConteudo>
                  <ArquivoAcao>
                    <IconExternalLink size={16} color="var(--c353a40)" />
                  </ArquivoAcao>
                </Arquivo>
              ))}
            </ValorDestacado>
          </div>
        )}

        {arquivosAta.length > 0 && (
          <div>
            <Rotulo>Ata do processo:</Rotulo>
            <ValorDestacado>
              {arquivosAta.map((arquivo: any, index: number) => (
                <Arquivo key={arquivo.id_proposta_arquivo || index} onClick={() => handleArquivoClick(arquivo)}>
                  <ArquivoIcone>
                    <IconDocumentUpload size={16} />
                  </ArquivoIcone>
                  <ArquivoConteudo>
                    <ArquivoNome>{arquivo?.caminho?.split("/").pop() || "--"}</ArquivoNome>
                    {arquivo.tamanho != null && (
                      <ArquivoTamanho>{formatFileSize(arquivo.tamanho)}</ArquivoTamanho>
                    )}
                  </ArquivoConteudo>
                  <ArquivoAcao>
                    <IconExternalLink size={16} color="var(--c353a40)" />
                  </ArquivoAcao>
                </Arquivo>
              ))}
            </ValorDestacado>
          </div>
        )}
      </Conteudo>
    </Cartao>
  );
}